<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div v-if="!showKycGroup" v-show="!showKycGroup && !showMerchantStaffKycUpdate" class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Merchant"
              bc1="App"
              bc2="Merchant"
              bc3="Profile"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="backTo"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">

        <section id="page-account-settings">
          <div class="row">
            <!-- left menu section -->
            <div class="col-md-3 mb-2 mb-md-0">
              <ul class="nav nav-pills flex-column nav-left">
                <!-- general -->
                <li class="nav-item" @click="currentTab = 1">
                  <a class="nav-link active" id="account-pill-general" data-toggle="pill" href="#account-vertical-general" aria-expanded="true">

                    <feather type="layers" class="font-medium-3 mr-1 font-weight-bolder"></feather
                    >
                    <span class="font-weight-bold">General</span>
                  </a>
                </li>
                <!-- change password -->
                <li class="nav-item" @click="currentTab = 2">
                  <a class="nav-link" id="account-pill-password" data-toggle="pill" href="#account-vertical-password" aria-expanded="false">
                    <feather type="shopping-cart" class="font-medium-3 mr-1 font-weight-bolder"></feather
                    >
                    <span class="font-weight-bold">Stores</span>
                  </a>
                </li>
                <!-- information -->
                <li class="nav-item" @click="currentTab = 3">
                  <a class="nav-link" id="account-pill-info" data-toggle="pill" href="#account-vertical-info" aria-expanded="false">
                    <feather type="terminal" class="font-medium-3 mr-1 font-weight-bolder"></feather
                    >
                    <span class="font-weight-bold">Terminals</span>
                  </a>
                </li>

                <li class="nav-item" @click="currentTab = 4">
                  <a class="nav-link" id="account-pill-notifications" data-toggle="pill" href="#account-vertical-notifications" aria-expanded="false">
                    <feather type="grid" class="font-medium-3 mr-1 font-weight-bolder"></feather
                    >
                    <span class="font-weight-bold">Channels</span>
                  </a>
                </li>
                <li class="nav-item" @click="currentTab = 5">
                  <a class="nav-link" id="account-pill-notifications2" data-toggle="pill" href="#account-vertical-notifications2" aria-expanded="false">
                    <feather type="user" class="font-medium-3 mr-1 font-weight-bolder"></feather
                    >
                    <span class="font-weight-bold">Staff</span>
                  </a>
                </li>
                <li class="nav-item" @click="currentTab = 6">
                  <a class="nav-link"  data-toggle="pill" href="javascript:void(0)" @click="showKycGroup = true" aria-expanded="false">
                    <feather type="users" class="font-medium-3 mr-1 font-weight-bolder"></feather
                    >
                    <span class="font-weight-bold">Kyc Groups</span>
                  </a>
                </li>
              </ul>
            </div>
            <!--/ left menu section -->

            <!-- right content section -->
            <div class="col-md-9">
              <div class="card">
                <div class="card-body">
                  <div class="tab-content">
                    <!-- general tab -->
                    <div role="tabpanel" class="tab-pane active" id="account-vertical-general" aria-labelledby="account-pill-general" aria-expanded="true">
                      <!-- header media -->
                      <div class="media">
                        <a href="javascript:void(0);" class="mr-25">
                          <img :src="profileImage? profileImage: '/app-assets/images/portrait/small/avatar-user.png'" id="account-upload-img" class="rounded mr-50" alt="profile image" height="80" width="80" />
                        </a>
                        <!-- upload and reset button -->
<!--                        <div class="media-body mt-75 ml-1">-->
<!--                          <label for="account-upload" class="btn btn-sm btn-primary mb-75 mr-75">Upload</label>-->
<!--                          <input type="file" id="account-upload" hidden accept="image/*" />-->
<!--                          <button class="btn btn-sm btn-outline-secondary mb-75">Reset</button>-->
<!--                        </div>-->
                        <!--/ upload and reset button -->
                      </div>
                      <!--/ header media -->

                      <!-- form -->
                      <form class="validate-form mt-2">
                        <div class="row">
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label for="account-username">First Name</label>
                              <input type="text" class="form-control" id="account-username" name="username" v-model="firstName" />
                            </div>
                          </div>
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label for="account-name">Last Name</label>
                              <input type="text" class="form-control" id="account-name" name="name" v-model="lastName" />
                            </div>
                          </div>
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label for="account-e-mail">E-mail</label>
                              <input type="email" disabled class="form-control" id="account-e-mail" v-model="email" />
                            </div>
                          </div>
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label for="account-company">Phone</label>
                              <input type="text" class="form-control" id="account-company" v-model="phone" />
                            </div>
                          </div>
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label for="account-company">Business Name</label>
                              <input type="text" class="form-control" id="account-company" v-model="businessName" />
                            </div>
                          </div>
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label for="account-risk">Risk</label>
                              <select class="form-control" id="account-risk" v-model="riskLevel">
                                <option :value="null" disabled>Select Risk</option>
                                <option :value="0">Low</option>
                                <option :value="1">Medium</option>
                                <option :value="2">High</option>
                              </select>
                            </div>
                          </div>
<!--                          <div class="col-12 col-sm-6">-->
<!--                            <div class="form-group">-->
<!--                              <label for="account-user-type">User Type</label>-->
<!--                              <div v-if="userTypesLoading" class="d-flex align-items-center">-->
<!--                                <clip-loader-->
<!--                                    :loading="true"-->
<!--                                    color="#007bff"-->
<!--                                    size="12px"-->
<!--                                ></clip-loader>-->
<!--                              </div>-->
<!--                              <select v-else class="form-control" id="account-user-type" v-model="selectedUserType">-->
<!--                                <option :value="null" disabled>Select User Type</option>-->
<!--                                <option v-for="type in userTypes" :key="type.id" :value="type.id">{{ type.name }}</option>-->
<!--                              </select>-->
<!--                            </div>-->
<!--                          </div>-->
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label>Payfac Merchant</label>
                              <div class="custom-control custom-control-success custom-switch mt-50">
                                <input id="is-payfac-merchant" type="checkbox" class="custom-control-input" v-model="isPayfacMerchant" />
                                <label class="custom-control-label" for="is-payfac-merchant">
                                  {{ isPayfacMerchant ? 'Yes' : 'No' }}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label for="account-partner">Partner</label>
                              <select class="form-control" id="account-partner" v-model="selectedPartnerId" :disabled="partnersLoader" @change="handlePartnerSelected">
                                <option :value="null">{{ partnersLoader ? 'Loading partners...' : 'Select' }}</option>
                                <option v-for="partner in partners" :key="partner.id" :value="partner.id">
                                  {{ partnerFormatter(partner) }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-12 col-sm-6" v-if="selectedPartner">
                            <div class="form-group">
                              <label for="account-referral-code">Referral Code</label>
                              <select class="form-control" id="account-referral-code" v-model="referralCodeId">
                                <option :value="null" disabled>Select Referral Code</option>
                                <option v-for="code in partnerReferralCodes" :key="code.id" :value="code.id">
                                  {{ code.code }}{{ code.status == 1 ? '' : ' (Inactive)' }}
                                </option>
                              </select>
                              <small v-if="partnerReferralCodes.length == 0" class="text-muted">This partner has no referral codes.</small>
                            </div>
                          </div>
                          <div class="col-12">
                            <button type="submit" class="btn btn-primary mt-2 mr-1 d-flex" :disabled="updateProfileLoader" @click="UpdateProfile">
                              <Loader :loading="updateProfileLoader" size="10px"></Loader>
                              Save changes
                            </button>
                          </div>
                        </div>
                      </form>
                      <!--/ form -->
                    </div>
                    <!--/ general tab -->

                    <!-- change password -->
                    <div class="tab-pane fade" id="account-vertical-password" role="tabpanel" aria-labelledby="account-pill-password" aria-expanded="false">
                      <!-- form -->
                        <div class="row">
                          <div class="col-12">
                            <div class="d-flex align-items-center mb-2">
                              <i data-feather="link" class="font-medium-3"></i>
                              <h4 class="mb-0 ml-75">Stores</h4>
                            </div>
                          </div>
                          <div class="table-responsive" >
                            <StoreTab v-if="currentTab == 2" :filter="filteredData" />
                          </div>

                        </div>
                      <!--/ form -->
                    </div>
                    <!--/ change password -->

                    <!-- information -->
                    <div class="tab-pane fade" id="account-vertical-info" role="tabpanel" aria-labelledby="account-pill-info" aria-expanded="false">
                      <div class="row">
                        <div class="col-12">
                          <div class="d-flex align-items-center mb-2">
                            <i data-feather="link" class="font-medium-3"></i>
                            <h4 class="mb-0 ml-75">Terminals</h4>
                          </div>
                        </div>
                        <div class="table-responsive" >
                          <TerminalTab v-if="currentTab == 3" :filter="filteredData" />
                        </div>

                      </div>
                    </div>
                    <!--/ information -->

                    <!-- social -->
<!--                    <div class="tab-pane fade" id="account-vertical-social" role="tabpanel" aria-labelledby="account-pill-social" aria-expanded="false">-->
<!--                      &lt;!&ndash; form &ndash;&gt;-->
<!--                      <div class="row" >-->
<!--                        <div class="col-12">-->
<!--                          <div class="d-flex align-items-center mb-2">-->
<!--                            <i data-feather="link" class="font-medium-3"></i>-->
<!--                            <h4 class="mb-0 ml-75">Channels</h4>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <div class="table-responsive" >-->
<!--                          <CommonTable-->
<!--                              :url="showChannel"-->
<!--                              :tableHeaderValues="tableHeaderValues"-->
<!--                              :actions="actions"-->
<!--                              :deleteActions="deleteActions"-->
<!--                              :mutedData="mutedData"-->
<!--                              storageKey="merchantInnerChannelList"-->
<!--                              :filteredData="filteredData"-->
<!--                              :externalTotalRecord="externalTotalRecord"-->
<!--                          />-->
<!--                        </div>-->

<!--                      </div>-->
<!--                      &lt;!&ndash;/ form &ndash;&gt;-->
<!--                    </div>-->
                    <!--/ social -->

                    <div class="tab-pane fade" id="account-vertical-notifications" role="tabpanel" aria-labelledby="account-pill-notifications" aria-expanded="false">
                      <div class="row">
                        <div class="col-12">
                          <div class="d-flex align-items-center mb-2">
                            <i data-feather="link" class="font-medium-3"></i>
                            <h4 class="mb-0 ml-75">Channels</h4>
                          </div>
                        </div>
                        <template v-if="showChannels">
                          <ChannelTab  :filter="channelFilteredData" />
                        </template>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="account-vertical-notifications2" role="tabpanel" aria-labelledby="account-pill-notifications2" aria-expanded="false">
                      <div class="row">
                        <div class="col-12">
                          <div class="d-flex align-items-center mb-2">
                            <i data-feather="link" class="font-medium-3"></i>
                            <h4 class="mb-0 ml-75">Staff</h4>
                          </div>
                        </div>
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                            <tr>
                              <th class="py-1">S.No</th>
                              <th class="py-1">Email</th>
                              <th class="py-1">First Name</th>
                              <th class="py-1">Last Name</th>
                              <th class="py-1">Status</th>
                              <th class="py-1">Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="!staffData.length">
                              <td
                                colspan="5"
                                class="font-weight-bolder font-medium-2"
                                style="text-align: center"
                              >
                                No data available
                              </td>
                            </tr>
                              <tr v-for="(item,index) in staffData">
                                <td class="py-1">
                                  <span class="font-weight-bold">{{index+1}}</span>
                                </td>
                                <td class="py-1">
                                  <span class="font-weight-bold">{{item.email}}</span>
                                </td>
                                <td class="py-1">
                                  <span class="font-weight-bold">{{item.first_name}}</span>
                                </td>
                                <td class="py-1">
                                  <span class="font-weight-bold">{{item.last_name}}</span>
                                </td>
                                <td class="py-1">
                                  <span v-if="item.status == 1" class="badge badge-light-success badge-glow badge-sm">Active</span>
                                  <span v-else-if="item.status == 3" class="badge badge-light-warning badge-glow badge-sm">Suspended</span>
                                  <span v-else class="badge badge-light-danger badge-glow badge-sm">Inactive</span>
                                </td>
                                <td class="d-flex">
                                  <!--                                  <button class="btn btn-sm btn-warning btn-sm" @click="$router.push({name: 'account-ledger',params: {id:account.id}})">Ledger</button>-->
                                  <button class="btn btn-sm btn-primary  btn-sm" @click="updateMerchantStaffKycDetails(item,index)" >Kyc</button>
                                  <button  class="btn btn-sm btn-primary btn-sm ml-1 " @click="updateStaffStatus(item,index)" >Status</button>
                                  <button  class="btn btn-sm btn-primary btn-sm ml-1 " @click="$router.push({name: 'get-logs',params: {id:item.uuid,propFilters: propFilters}})" >Logs</button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--/ right content section -->
          </div>
        </section>


      </div>
    </div>
    <MerchantStaffUpdateStatus
        :show="showMerchantStaffModal"
        :id="merchantStaffUuid"
        :status="merchantStaffStatus"
        :row="merchantStaffRow"
        :index="merchantStaffIndex"
        vuexKey="merchantStaff"
        @hide="showMerchantStaffModal = false"
        @statusUpdated="statusUpdated"
    ></MerchantStaffUpdateStatus>
    <KycGroups usedFor="merchant" v-if="showKycGroup" @hideKycGroup="showKycGroup = false;currentTab = 1"></KycGroups>
    <MerchantStaffKycUpdate @hide="showMerchantStaffKycUpdate = false" :id="merchantStaffUuid" v-if="showMerchantStaffKycUpdate" ></MerchantStaffKycUpdate>
  </div>
</template>

<script>

import KycGroups from "@/pages/dashboard/merchant/KycGroups";
import MerchantStaffUpdateStatus from "./MerchantStaffUpdateStatus";
import MerchantStaffKycUpdate from "./MerchantStaffKycUpdate";
import StoreTab from "@/pages/dashboard/merchant/profile-tabs/StoreTab.vue";
import TerminalTab from "@/pages/dashboard/merchant/profile-tabs/TerminalTab.vue";
import CommonTableCustomRow from "@/components/dashboard/common/CommonTableCustomRow.vue";
import ChannelTab from "@/pages/dashboard/merchant/profile-tabs/ChannelTab.vue";
export default {
  props: ['propFilters'],
  components:{
    ChannelTab,
    CommonTableCustomRow,
    TerminalTab,
    StoreTab,
    KycGroups,
    MerchantStaffUpdateStatus,
    MerchantStaffKycUpdate
  },
  mounted() {
    localStorage.setItem("url", "v1/get-store");
    this.checkDataInStore('v1/get-store')
    var merchantProfileData = this.$store.getters.getByKey(
        "merchantProfileData"
    );
    this.userId = merchantProfileData.row.id
    this.filteredData = {
      userId: this.userId
    }

    this.profileImage =  merchantProfileData.row.avatar
    this.firstName =  merchantProfileData.row.first_name
    this.lastName =  merchantProfileData.row.last_name
    this.email =  merchantProfileData.row.email
    this.phone =  merchantProfileData.row.phone_number
    this.businessName =  merchantProfileData.row.business_name
    this.riskLevel =  merchantProfileData.row.risk
    this.uuid =  merchantProfileData.row.uuid

    let referralCode = merchantProfileData.row.referral_code
    if (referralCode) {
      this.selectedPartnerId = referralCode.user_id || null
      this.referralCodeId = referralCode.id || null
    }

    this.getMerchantDetails()
    // this.fetchUserTypes()
    this.getPartners()

  },
  data() {
    return {
      merchantStaffUuid:'',
      riskLevel:null,
      partners: [],
      partnersLoader: false,
      selectedPartnerId: null,
      referralCodeId: null,
      merchantStaffStatus:'',
      merchantStaffIndex:'',
      merchantStaffRow:'',
      showMerchantStaffModal:false,
      showMerchantStaffKycUpdate:false,
      uuid:'',
      profileImage:'',
      firstName:'',
      lastName:'',
      email:'',
      phone:'',
      businessName:'',
      userTypes: [],
      selectedUserType: 1,
      userTypesLoading: false,
      isPayfacMerchant: false,
      url: "v1/get-store",
      storageKey: "merchantInnerStoreList",
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name",
          html: true
        },
        {
          title: "Code",
          valueKey: "code",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-primary">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == true) {
              html = `<span class="badge badge-success badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-sm">Inactive</span>`;
            }


            return html;
          }
        }
      ],
      actions: [],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: "",
      filteredData:{},
      userId:'',
      channels:[],
      currentTab:1,
      showStore:'',
      showTerminal:'',
      showChannel:'',
      updateProfileLoader: false,
      staffData: [],
      showKycGroup:false,
      channelFilteredData: { userId: this.userId,uuid:this.uuid },
      showChannels: false,
    }
  },
  computed: {
    selectedPartner() {
      return this.partners.find(partner => partner.id == this.selectedPartnerId) || null
    },
    partnerReferralCodes() {
      return this.selectedPartner && Array.isArray(this.selectedPartner.referral_codes)
          ? this.selectedPartner.referral_codes
          : []
    }
  },
  methods: {
    partnerFormatter(partner) {
      let name = partner.business_name || ((partner.first_name || '') + ' ' + (partner.last_name || '')).trim()
      return partner.email ? name + ' / ' + partner.email : name
    },
    handlePartnerSelected() {
      // partner changed, so any previously picked code no longer applies
      this.referralCodeId = null
    },
    getPartners() {
      this.partnersLoader = true
      this.makeRequest("post", "v1/get-partners", {flag: 'all', details: 1}, {}, false).then(
          callResponse => {
            this.partnersLoader = false
            if (!callResponse.error && callResponse.response.data.code == 200) {
              let data = callResponse.response.data.data
              // unpaginated response returns the list directly, paginated wraps it in data.data
              this.partners = Array.isArray(data) ? data : (data && Array.isArray(data.data) ? data.data : [])
            }
          }
      )
    },
    statusUpdated(status){
      this.showMerchantStaffModal = false
      this.staffData[this.merchantStaffIndex].status = status
    },
    updateMerchantStaffKycDetails(item,index){
      this.merchantStaffUuid = item.id
      this.showMerchantStaffKycUpdate = true
    },
    updateStaffStatus(item,index){
      this.merchantStaffRow = item
      this.merchantStaffIndex = index
      this.merchantStaffStatus = item.status
      this.merchantStaffUuid = item.id
      this.showMerchantStaffModal = true
    },
    getMerchantDetails() {
      this.makeRequest('post', 'v1/detail-merchant', {id: this.userId}, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            if(data){
              this.staffData = data.staff
              if(data.merchantType){
                this.selectedUserType = data.merchantType
              }
              this.isPayfacMerchant = data.is_payfac_merchant == 1 || data.is_payfac_merchant === true
            }
          }
        }

      });

    },
    fetchUserTypes() {
      this.userTypesLoading = true
      this.makeRequest('post', 'v1/get-users-types', {}, {}, false).then(callResponse => {
        this.userTypesLoading = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let data = callResponse.response.data.data;
            if(data){
              this.userTypes = data;
            }
          }
        }
      });
    },
    backTo(){
      let propFilters = this.propFilters
      this.$router.push({name:'merchants',params:{propFilters}})
    },
    UpdateProfile(){
      this.updateProfileLoader = true
      let data = {
        firstName:this.firstName,
        lastName:this.lastName,
        phoneNumber:this.phone,
        riskLevel:this.riskLevel,
        // roleId:3,
        // email:this.email,
        businessName:this.businessName,
        uuid:this.uuid,
        // userType: this.selectedUserType,
        isPayfacMerchant: this.isPayfacMerchant ? 1 : 0
      }
      if (!this.selectedPartnerId) {
        // no partner selected, clear the referral code on the merchant
        data.referralCodeId = ''
      } else if (this.referralCodeId) {
        data.referralCodeId = this.referralCodeId
      }

      this.makeRequest("post", "v1/update-admin-user", data).then(
        callResponse => {
          this.updateProfileLoader = false
        }

      )
    },
    getMerchantGroups(){
      this.makeRequest("post", "v1/merchant-schema-acquiring", {uuid:this.uuid,userId:this.userId}, {}, false).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = []
                data = callResponse.response.data.data;
                if(data){
                  this.channels = data.channels
                }


              }
            }
          }
      );
    },

  },
  watch:{
    currentTab(val){
      if(val == 4){
        this.channelFilteredData = {
          userId: this.userId,
          uuid:this.uuid
        }
        this.showChannels = true
      }else if(val == 2){
        this.showStore = 'v1/get-store'
      }
      else if(val == 3){
        this.showTerminal = 'v1/get-terminal'
      }
      // else if(val == 4){
      //   this.showChannel = 'v1/get-channel'
      // }
    }
  }

}
</script>



